export default "__VITE_ASSET__DOIc7oF___"